import { useEffect, useMemo, useRef, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~db/db";
import prepareForOptions from "~services/utils/prepareForOptions";

const useTodasCidades = (todosOsClientes = [], selectMicro, filtros, config = {}) => {
  const [cidades, setCidades] = useState([]);
  const [cidade, setCidade] = useState(0);
  const [onCidade, setOnCidade] = useState(false);
  const cidadeSelect = useSelect("cidades");
  const { salvarLocalStorage = false, chave } = config;
  const restoredCidadeRef = useRef(false);

  useEffect(() => {
    const fetchCidades = async (clientes) => {
      const cidadesMap = new Map();

      clientes.forEach((cliente) => {
        const cidade = cliente?.endereco?.cidade;
        if (cidade?.id) {
          cidadesMap.set(cidade.id, { ...cidade });
        }
      });

      const lista = Array.from(cidadesMap.values()).sort((a, b) =>
        a.nome.localeCompare(b.nome)
      );

      const cidadeIds = lista.map((cidade) => cidade.id).filter(Boolean);
      const cidadesDb = cidadeIds.length ? await db.cidades.bulkGet(cidadeIds) : [];
      const microrregiaoPorCidadeId = new Map(
        (cidadesDb || [])
          .filter(Boolean)
          .map((cidadeDb) => [cidadeDb.id, cidadeDb.microrregiaoId])
      );

      const cidadesComMicrorregiao = lista.map((cidade) => {
        const microrregiaoId = microrregiaoPorCidadeId.get(cidade.id);
        return microrregiaoId ? { ...cidade, microrregiaoId } : cidade;
      });

      const cidadesFiltradas =
        selectMicro && selectMicro.value !== 0
          ? cidadesComMicrorregiao.filter(
              (c) => c.microrregiaoId === selectMicro.value
            )
          : cidadesComMicrorregiao;

      setCidades(cidadesFiltradas);
    };

    if (Array.isArray(todosOsClientes)) {
      fetchCidades(todosOsClientes);
    }
  }, [todosOsClientes, selectMicro]);

  const optionCidades = useMemo(() => {
    return prepareForOptions(cidades, ["nome"], "id");
  }, [cidades]);

  function onChangeCidade(e) {
    setOnCidade(e?.value > 0);
    cidadeSelect.upDateValue(e?.value);
    cidadeSelect.upDateDefaultValue(e || "");
    if (salvarLocalStorage && todosOsClientes.length > 0) {
      localStorage.setItem(chave, JSON.stringify(e));
    }
    setCidade(e?.value || 0);
  }

     useEffect(() => {
    if(salvarLocalStorage && !restoredCidadeRef.current){
      const cidadeSalva = localStorage.getItem(chave);
      if (cidadeSalva) {
        const cidadeObj = JSON.parse(cidadeSalva);
        setCidade(cidadeObj.value);
        onChangeCidade(cidadeObj);
      }
      restoredCidadeRef.current = true;
    }
  }, [salvarLocalStorage, chave])

  function searchCidadeById(id) {
    return cidades.find((c) => c.id === id);
  }

  function CleanForFilter(option) {
    onChangeCidade(option);
  }
  useEffect(() => {
  if (cidades.length > 0 && cidade > 0 && !cidades.find((c) => c.id === cidade)) {
    const option = { value: 0, label: "Todos" };

     setOnCidade(option?.value > 0);
    cidadeSelect.upDateValue(option?.value);
    cidadeSelect.upDateDefaultValue(option|| "");
    setCidade(option?.value || 0);
    filtros.cidadeId = undefined;
  }
}, [cidades, cidade]);


  return {
    cidades,
    optionCidades,
    cidade,
    onCidade,
    cidadeSelect,
    onChangeCidade,
    searchCidadeById,
    CleanForFilter,
  };
};

export default useTodasCidades;
